import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["checked", "onChange"];
import { Checkbox as CheckboxFoundations } from 'foundations-components/transitional/components/Checkbox';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { InputLabel } from '../Typography/InputLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export const Checkbox = _ref => {
  let {
      checked,
      onChange
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  const handleChange = event => {
    onChange(event.target.checked);
  };
  return /*#__PURE__*/_jsx(CheckboxFoundations, Object.assign({}, rest, spacingProps, {
    checked: checked,
    onChange: handleChange
  }));
};
Checkbox.Label = InputLabel;